/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'retry': {
    width: 16,
    height: 16,
    viewBox: '0 0 34 34',
    data: '<path pid="0" d="M16.1 6.4L13.7 4c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l4.2 4.2c.4.4.4 1 0 1.4l-4.2 4.2c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4l2.7-2.7c-5.6.4-10.1 5-10.1 10.7 0 5.9 4.8 10.7 10.7 10.7 5.9 0 10.7-4.8 10.7-10.7 0-.6.4-1 1-1s1 .4 1 1c0 7-5.7 12.7-12.7 12.7S4.3 26 4.3 19c0-6.7 5.2-12.1 11.8-12.6z"/>'
  }
})
